/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_SystemSettings {
    ContactPersonOnboardingAccountSetupEmailTemplateSubject = 120,
    ContactPersonOnboardingAccountSetupEmailTemplateContent = 121,
    ContactPersonOnboardingAccountCreatedEmailTemplateSubject = 122,
    ContactPersonOnboardingAccountCreatedEmailTemplateContent = 123,
    DefaultTimeSpan = 124,
    BlackListedFileTypes = 125,
    CustomerPortalCustomerLoginOverrideURL = 710,
    DefaultProjectLabels = 720,
    ConfigurationsLimit = 730,
    CopyConfigurationsLimit = 740,
    /**
     * Outside Production only: "1" forces the Business Central configuration import to skip the rules that reject changed list values; "0" (default) keeps them in force.
     */
    ForceBCImportStaging = 750,
    CopyConfigurationItemsLimit = 760,
    /**
     * The ListId (GUID) of the List whose items are the valid module measurements ("Modulmål").
     * Unset, or unparseable, leaves it , which disables
     * dimension-to-measurement resolution rather than failing the read.
     */
    DimensionsListId = 770,
    /**
     * Monotonic counter bumped by every configurator cache reset; each process compares it with the generation it last evicted at to detect a missed reset signal.
     */
    ConfiguratorCacheGeneration = 780,
    SeedDataVersion = 810,
}
